<script lang="ts" setup>
import { isElementVisible } from 'core'
import { getPeaksSVG } from './utils'

const props = defineProps<{ peaks: number[] }>()
const wrapperRef = ref<HTMLElement>()

function render(animate = false) {
  const wrapper = wrapperRef.value

  return requestAnimationFrame(() => {
    // Exit as component is not mounted
    if (!wrapper)
      return

    if (!props.peaks)
      throw new Error('Given peaks data is null')

    const image = getPeaksSVG({
      peaks: props.peaks,
      rect: wrapper.getBoundingClientRect(),
      animate: animate && isElementVisible(wrapper),
      barWidth: 1
    })

    // Set mask image
    wrapper.style.setProperty('--image', image.getDataURL(true))
    wrapper.style.opacity = '1'
  })
}

const onResize = debounce(250, () => render())

onMounted(() => render(true))
useEventListener('resize', onResize, { passive: true })
</script>

<template>
  <div ref="wrapperRef" :class="$style.wrapper" />
</template>

<style module lang="sass">
.wrapper
  --bar-color: var(--player-bar-color, theme('colors.primary.200'))
  --bar-fill-color: var(--player-bar-fill-color, theme('colors.primary.500'))

  @apply h-40px w-full relative pointer-events-none overflow-hidden contain-strict opacity-0

  // Mask image
  mask-image: var(--image)
  mask-repeat: no-repeat
  mask-size: 100% 40px

  -webkit-mask-image: var(--image)
  -webkit-mask-repeat: no-repeat
  -webkit-mask-size: 100% 40px

  // Colors
  @apply before:bg-$bar-color after:bg-$bar-fill-color

  // Overlay
  &::before, &::after
    @apply content-[''] absolute inset-0

  &::after
    // Set position
    --x: calc(var(--progress, 0%) - 100%)

    transform: translateX(var(--x))
    transition: transform 150ms ease
</style>
